export const NO_NAME_USER_LABEL = "!!NO NAME USER!!";

/**
 * `causer` is null for guest/system activity, but a real user row can also carry
 * a null or blank name (e.g. created via organisation invitation) — those must
 * be visibly flagged rather than silently rendered as a guest.
 */
export function getUserDisplayName(
  user: { name?: string | null } | null | undefined,
  guestLabel: string,
): string {
  if (!user) {
    return guestLabel;
  }

  return user.name?.trim() || NO_NAME_USER_LABEL;
}
